import { PAYMENT_COMMENT_478_ERROR_HANDLING } from "@/shared/checkout/constants";
import { cardTypesMap } from "@/shared/payment/constants";
import type { KeyValueType, PaymentInstrumentDetailsType } from "@/core/api/graphql/types";
import type { IPaymentOutputStateDetails } from "@/shared/payment";

export function decodeJwtPayload(
  token: string,
  cardholderName: string,
  isDefault: boolean,
): IPaymentOutputStateDetails {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map((c) => `%${("00" + c.charCodeAt(0).toString(16)).slice(-2)}`)
      .join(""),
  );
  const parseResult = JSON.parse(jsonPayload).content.paymentInformation.card;
  parseResult.cardholderName = cardholderName;
  parseResult.isDefault = isDefault;

  return {
    maskedCardNumber: parseResult.number.maskedValue,
    expirationMonth: parseResult.expirationMonth.value,
    expirationYear: parseResult.expirationYear.value,
    cardholderName: parseResult.cardholderName,
    cardType: parseResult.number.detectedCardTypes?.at(0),
  };
}

export const getCardTypeName = (code: string): string => {
  if (Object.keys(cardTypesMap).some((key) => cardTypesMap[key].toLocaleLowerCase() === code.toLocaleLowerCase())) {
    return code;
  }
  return cardTypesMap[code] ?? "Card";
};

export const fromCardDetailsToPaymentOutputStateDetails = (
  cardDetails: PaymentInstrumentDetailsType,
): IPaymentOutputStateDetails => {
  return {
    maskedCardNumber: cardDetails.maskedCardNumber.slice(-4),
    expirationMonth: cardDetails.expirationMonth,
    expirationYear: cardDetails.expirationYear,
    cardholderName: `${cardDetails.cardholderFirstName} ${cardDetails.cardholderLastName}`,
    isDefault: cardDetails.isDefault,
    cardType: cardDetails.cardType,
  };
};

export const create478PaymentComment = (authorizationParameters: KeyValueType[]) => {
  const cardTypeParam = (authorizationParameters.find((param) => param.key === "cardType")?.value as string) ?? "";
  const maskedCardNumberParam =
    (authorizationParameters.find((param) => param.key === "maskedCardNumber")?.value as string) ?? "";
  const expirationMonthParam =
    (authorizationParameters.find((param) => param.key === "expirationDate")?.value as string) ?? "";
  const cardholderNameParam =
    (authorizationParameters.find((param) => param.key === "cardholderName")?.value as string) ?? "";
  return `${PAYMENT_COMMENT_478_ERROR_HANDLING}|${cardTypeParam}|${maskedCardNumberParam}|${expirationMonthParam}|${cardholderNameParam}`;
};
